import { ActionNodeActionProxy } from '../index'
import { LabelsAction } from './LabelsAction'

export class LabelsActionProxy extends ActionNodeActionProxy {
  action: LabelsAction

  constructor(action: LabelsAction) {
    super()
    this.action = action
  }

  getModel(): LabelsAction {
    return this.action
  }

  setLabels(labels: Array<number>): void {
   this.action.label_index = labels
  }
}
